import { Bot, MessageCircle, BookOpen, Sparkles, Headphones, HelpCircle, ShoppingBag, Heart } from "lucide-react";

export const PRESET_ICONS = {
  bot: Bot,
  message: MessageCircle,
  book: BookOpen,
  sparkles: Sparkles,
  headset: Headphones,
  help: HelpCircle,
  cart: ShoppingBag,
  heart: Heart,
};

export const PRESET_ICON_KEYS = Object.keys(PRESET_ICONS);

const BACKEND = process.env.REACT_APP_BACKEND_URL;

export function iconImageUrl(fileId) {
  return `${BACKEND}/api/public/assets/${fileId}`;
}

// Renders an assistant's icon consistently everywhere.
// icon = { type: "preset"|"emoji"|"image", value }
export default function AssistantAvatar({ icon, color = "#0a0a0a", size = 40, className = "" }) {
  const type = icon?.type || "preset";
  const value = icon?.value;

  if (type === "image" && value) {
    return (
      <img
        src={iconImageUrl(value)}
        alt=""
        style={{ width: size, height: size }}
        className={`shrink-0 rounded-full object-cover ${className}`}
      />
    );
  }

  const Icon = PRESET_ICONS[value] || Bot;
  return (
    <div
      style={{ width: size, height: size, backgroundColor: color }}
      className={`flex shrink-0 items-center justify-center rounded-full text-white ${className}`}
    >
      {type === "emoji" && value ? (
        <span style={{ fontSize: size * 0.52, lineHeight: 1 }}>{value}</span>
      ) : (
        <Icon style={{ width: size * 0.5, height: size * 0.5 }} />
      )}
    </div>
  );
}
